import { Collapse } from 'bootstrap';
import SmoothScroll from 'smooth-scroll';
import Splide from '@splidejs/splide';

(function ($, root, undefined) {
	
	$(function () {
		
		'use strict';
		console.log('ready');

		var scroll = new SmoothScroll('a[href*="#"]', {
			topOnEmptyHash: true,
			speed: 500,
			speedAsDuration: true,
			offset: 78,
			easing: 'easeInOutQuad',
		});

		const burgerMenu = document.getElementById("burger");
		const navbarMenu = document.getElementById("menu");

// Show and Hide Navbar Menu
		if (burgerMenu) {
			burgerMenu.addEventListener("click", () => {
				burgerMenu.classList.toggle("is-active");
				navbarMenu.classList.toggle("is-active");

				if (navbarMenu.classList.contains("is-active")) {
					navbarMenu.style.maxHeight = navbarMenu.scrollHeight + "px";
				} else {
					navbarMenu.removeAttribute("style");
				}
			});
		}

		const heroSlider = document.querySelectorAll('.hero__slider');

		if (heroSlider) {
			heroSlider.forEach((slider)=>{
				new Splide( slider, {
					type: 	'loop',
					autoplay: "play",
					speed: 2000,
					interval:  5000,
					rewind     : true,
					pagination : true,
					arrows: false,
				} ).mount();
			});
		}

	});
	
})(jQuery, this);
